/******************** FIREBASE SDK CONFIG ********************/
  // Import the functions you need from the SDKs you need
  import { initializeApp } from "firebase/app";
  //import { getAnalytics } from "https://www.gstatic.com/firebasejs/12.3.0/firebase-analytics.js";
  import { getAuth } from "firebase/auth"; 
  import { getDatabase } from "firebase/database";
  // TODO: Add SDKs for Firebase products that you want to use
  // https://firebase.google.com/docs/web/setup#available-libraries

  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  const firebaseConfig = {
    apiKey: "AIzaSyDVpX_2wIef8JSN6F36eRV2oOVEAJDN8xw",
    authDomain: "tour-in-a-box.firebaseapp.com",
    databaseURL: "https://tour-in-a-box-default-rtdb.firebaseio.com",
    projectId: "tour-in-a-box",
    storageBucket: "tour-in-a-box.firebasestorage.app",
    messagingSenderId: "477486825997",
    appId: "1:477486825997:web:fa36e96e548b36f7944b44",
    measurementId: "G-H2LKWWFPRP"
  };

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  //const analytics = getAnalytics(app);

  // Export the Auth object and Database
  export const auth = getAuth(app);
  export const db = getDatabase(app);
  export const database = db; // Alias for consistency 